import { getOidc } from '@/features/oidc/oidc'
import { Oidc } from 'oidc-spa'
import { getTracking } from '@vgw/multibrand-fe-tracking'
import { reportError } from '@/lib/report-error'

type PlayerSessionLoggedIn = {
  isUserLoggedIn: true
  login?: never
  logout: (
    params: Parameters<Oidc.LoggedIn<Record<string, string>>['logout']>[0],
  ) => Promise<void>
}

type PlayerSessionNotLoggedIn = {
  isUserLoggedIn: false
  initializationError: boolean
  login: (params: Parameters<Oidc.NotLoggedIn['login']>[0]) => Promise<void>
  logout?: never
}

export async function getPlayerSession(): Promise<
  PlayerSessionLoggedIn | PlayerSessionNotLoggedIn
> {
  const oidc = await getOidc()
  const { reset } = getTracking()

  if (oidc.isUserLoggedIn) {
    return {
      isUserLoggedIn: true,
      logout: async (
        params: Parameters<Oidc.LoggedIn<Record<string, string>>['logout']>[0],
      ) => {
        // Reset prevents login and registration events from being assigned to the current user
        // Without it, tracking multiple players on the same browser will be incorrect
        reset()
        return oidc.logout?.(params)
      },
    }
  }

  if (oidc.initializationError) {
    reportError(oidc.initializationError)
  }

  return {
    isUserLoggedIn: false,
    login: async (params: Parameters<Oidc.NotLoggedIn['login']>[0]) => {
      // Reset prevents login and registration events from being assigned to the current user
      // Without it, tracking multiple players on the same browser will be incorrect
      reset()
      return oidc.login(params)
    },
    initializationError: !!oidc.initializationError,
  }
}
